<template>
  <div class="container bg-white">
    <div class="album py-5 bg-white">
      <div class="container">
        <div class="row row-cols-1 row-cols-sm-2 row-cols-md-3 g-4">
          <div class="col" v-for="post in posts" :key="post._id">
            <div class="card shadow-sm">
              <div class="staff-image">
                <img
                  v-if="post.image"
                  :src="imageUrlFor(post.image)"
                  class="staff"
                  alt=""
                />
              </div>
              <div class="card-body">
                <h1 class="card-text text-start">
                  <router-link
                    class="detail-button"
                    :to="`/clinical-research-detail/${post.slug.current}`"
                  >
                    {{ post.title }}
                  </router-link>
                </h1>
                <p class="text-start mb-0">
                  {{ post.position }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import sanity from "../client";
import imageUrlBuilder from "@sanity/image-url";
const imageBuilder = imageUrlBuilder(sanity);

const query = `*[_type == "clinicalResearch"] | order(positionLevel asc, _createdAt asc) {
      _id,
      title,
      slug,
      position,
      "image": mainImage.asset->url
    }  [0...50]`;
export default {
  name: "Clinical Trials",
  data() {
    return {
      posts: [],
    };
  },
  created() {
    this.fetchData();
  },
  methods: {
    imageUrlFor(source) {
      return imageBuilder.image(source);
    },
    async fetchData() {
      this.error = this.post = null;
      this.loading = true;
      try {
        const posts = await sanity.fetch(query);
        this.posts = posts;
      } catch (error) {
        this.error = error;
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.staff-image {
  height: 235px;
}
.staff {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: top;
}
.card-text {
  font-size: 22px;
  font-weight: bold;
  color: #000;
}
</style>
